import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { keyEscape } from '@microsoft/fast-web-utilities';
import { ChameleonElementMixin } from '../common/mixin';
export class DatePickerComponent extends ChameleonElementMixin(FoundationElement) {
    constructor() {
        super(...arguments);
        this.popoverMode = false;
        this.value = '';
        this.disabled = false;
        this.error = false;
        this.placeholder = 'MM-DD-YYYY';
        this.position = 'bottom-start';
        this.locale = 'en-US';
        this.handleContentKeydown = (event) => {
            event.stopPropagation();
            const key = event.key;
            if (key === keyEscape) {
                this.closePopover();
                this.field.focus();
            }
            return true;
        };
        this.handleTextFieldKeydown = (event) => {
            if (event.key === 'Enter') {
                this.calendar.selectedDates = this.field.value;
            }
            //TODO: work on keyboard flow for popover mode. Maybe with the new popover API
            if (event.key === 'Tab' && this.popoverElement.hasAttribute('is-open')) {
                this.calendar.focus();
            }
            return true;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.calendar.selectedDates) {
            this.calendar.selectedDates = this.value;
        }
    }
    placeholderChanged(_oldValue, newValue) {
        if (newValue) {
            this.placeholder = newValue;
        }
    }
    valueChanged(oldValue, newValue) {
        if (newValue) {
            if (this.field) {
                this.field.value = newValue;
            }
            this.emitChangeEvent({ value: this.value });
        }
    }
    emitChangeEvent(emitProps) {
        this.$emit('change', emitProps, { bubbles: false });
    }
    handlePopoverChanged(event) {
        // We need to stop propagation here or the onChange for the DatePicker will trigger twice
        event.stopPropagation();
    }
    handleCalendarChanged(event) {
        var _a;
        if ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.selectedDates) {
            this.value = event.detail.selectedDates;
        }
    }
    closePopover() {
        this.popoverElement.close();
    }
}
__decorate([
    attr({ mode: 'boolean', attribute: 'popover-mode' })
], DatePickerComponent.prototype, "popoverMode", void 0);
__decorate([
    attr({ attribute: 'input-label' })
], DatePickerComponent.prototype, "inputLabel", void 0);
__decorate([
    attr({ attribute: 'helper-text' })
], DatePickerComponent.prototype, "helperText", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "value", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "disabled", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "error", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "placeholder", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "position", void 0);
__decorate([
    attr
], DatePickerComponent.prototype, "locale", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "field", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "popoverElement", void 0);
__decorate([
    observable
], DatePickerComponent.prototype, "calendar", void 0);
